/**
 * @returns {string} The environment your code is running in.
 */
export function getEnv () {
  return (process.env.ENVIRONMENT ?? process.env.NODE_ENV ?? '').toLowerCase()
}
